import { useAuth } from "@clerk/clerk-react";
import { useCallback } from "react";

/**
 * Thin API client bound to Clerk. Fetches a fresh session token on every call
 * so token refreshes are transparent (double-layer-auth Responsibility 1).
 */
export function useApi() {
  const { getToken } = useAuth();

  const request = useCallback(
    async <T = unknown>(path: string, options: RequestInit = {}): Promise<T> => {
      const token = await getToken();
      const res = await fetch(path, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers ?? {}),
          Authorization: `Bearer ${token ?? ""}`,
        },
      });
      const data = (await res.json().catch(() => null)) as
        | (T & { error?: string })
        | null;
      if (!res.ok) {
        throw new Error(data?.error ?? `request failed (${res.status})`);
      }
      return data as T;
    },
    [getToken],
  );

  return { request };
}
